/**
 * 菜单类型
 */
export enum TYPE_ENUM {
  /**
   * 菜单
   */
  MENU = 'MENU',
  /**
   * 按钮
   */
  BUTTON = 'BUTTON'
}

export const TYPE_LIST = [
  { label: '菜单', value: TYPE_ENUM.MENU },
  { label: '按钮', value: TYPE_ENUM.BUTTON }
];
